const StatementSection = () => (
  <section className="statement" aria-label="Personal statement">
    <div className="statement__line" aria-hidden="true">
      <span>Engineer the logic.</span>
      <span>Design the feeling.</span>
      <span>Ship the product.</span>
    </div>
    <p data-reveal>
      Meaningful software lives where sound engineering meets a thoughtful
      experience.
    </p>
  </section>
);

export default StatementSection;
